





















































import DictMixin from '@/mixins/dict-mixin';
import DimensionServices from '@/services/dimension';
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DimensionForm4 extends mixins(DictMixin) {
  @PropSync('syncSubSyncDefs') syncSubSyncDefs0!: any;
  @Prop() mode!: number;

  dimSrv = new DimensionServices();
  databases: string[] = [];
  sourceId: number = 1;
  async created() {
    let res = await this.dimSrv.getDatabaseList();
    this.databases = res.databases;
    this.sourceId = res.sourceId;
    this.source = this.syncSubSyncDefs0.sqlqueryConfig.source.name || '';
  }

  @Watch('mode')
  onModeChange() {
    this.source = this.syncSubSyncDefs0.sqlqueryConfig.source.name || '';
  }

  source: string = '';

  changeSource(e: string) {
    this.syncSubSyncDefs0.sqlqueryConfig.source.name = e;
    this.syncSubSyncDefs0.sqlqueryConfig.source.id = this.sourceId;
  }

  log: string = '';
  async runSql() {
    let res = await this.dimSrv.excuteSubSql(this.syncSubSyncDefs0);
    let { code } = res.header;
    if (code == 200) {
      this.log = JSON.stringify(res.payload);
    } else {
      this.log = res.header.msg;
    }
  }

  chearSql() {
    this.log = '';
  }
}
